'use client';

import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { TypographyRhythm } from '@jouzen/ecom-components/v3/TypographyRhythm';
import { useTranslations } from 'next-intl';

import RichText from '@/app/components/RichText';

const Content = () => {
  const t = useTranslations();
  return (
    <article>
      <LayoutGrid data-cy="page-guidelines-for-commercial-use-grid">
        <TypographyRhythm className="col-main">
          <Typography Element="h1" variant="h1" className="mb-16">
            {t('guidelines_for_commercial_use_title')}
          </Typography>

          <Typography className="mb-24">
            <RichText messageKey="guidelines_for_commercial_use_content" />
          </Typography>
        </TypographyRhythm>
      </LayoutGrid>
    </article>
  );
};

export default Content;
